export const FLOW_PLAYLIST_SCOPES = [
  'pre_flow',
  'flow_intro',
  'flow_transition',
  'flow_resume',
  'flow_outro',
  'after_flow',
  'slot',
] as const;

export type FlowPlaylistScope = (typeof FLOW_PLAYLIST_SCOPES)[number];

export type NonSlotFlowPlaylistScope = Exclude<FlowPlaylistScope, 'slot'>;

export const NON_SLOT_FLOW_PLAYLIST_SCOPES = FLOW_PLAYLIST_SCOPES.filter(
  (scope): scope is NonSlotFlowPlaylistScope => scope !== 'slot',
);

/** Event-managed flow playlists; hosts are not asked to provide media via Request. */
export const FLOW_PLAYLIST_SCOPES_WITHOUT_HOST_REQUEST = ['pre_flow', 'after_flow'] as const;

export type FlowPlaylistScopeWithoutHostRequest = (typeof FLOW_PLAYLIST_SCOPES_WITHOUT_HOST_REQUEST)[number];

export function flowPlaylistScopeAllowsHostRequest(scope: FlowPlaylistScope): boolean {
  return !(FLOW_PLAYLIST_SCOPES_WITHOUT_HOST_REQUEST as readonly FlowPlaylistScope[]).includes(scope);
}
